import { mapState } from 'vuex';

export const connectionMixin = {
  computed: {
    ...mapState({
      isOnline: state => (state as any).system.online
    })
  }
};
